// src/pages/Home.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout from "../Particals/Layout";

// Import pages
const Dashboard = React.lazy(() => import("./Dashboard"));
const DealerApprovals = React.lazy(() => import("./Approvels/DealerApprovals"));
const SpApprovals = React.lazy(() => import("./Approvels/SpApprovals"));
const AgentsApprovals = React.lazy(() => import("./Approvels/AgentsApprovals"));
const ApprovalDetail = React.lazy(() => import("./Approvels/ApprovalDetail"));

const DealerPlanList = React.lazy(() => import("./Packages/DealerPlanList"));
const AgentDealerPlanList = React.lazy(() => import("./Packages/AgentDealerPlanList"));
const FreePackageList = React.lazy(() => import("./Packages/FreePackageList"));
const General = React.lazy(() => import("./Packages/General"));
const AddZone = React.lazy(() => import("./Packages/AddZone"));
const PushNotification = React.lazy(() => import("./Packages/PushNotification")); // ✅ imported

const CategoryList = React.lazy(() => import("./Categories/CategoryList"));
const AddCategory = React.lazy(() => import("./Categories/AddCategory"));
const EditCategory = React.lazy(() => import("./Categories/EditCategory"));
const AddOfferCategory = React.lazy(() => import("./Categories/AddOfferCategory"));
const EditOfferCategory = React.lazy(() => import("./Categories/EditOfferCategory"));

const ReviewApprove = React.lazy(() => import("./Reviews/ReviewApprove"));
const MisReport = React.lazy(() => import("./Reports/MisReport"));
const Invoice = React.lazy(() => import("./Reports/Invoice"));

const Notification = React.lazy(() => import("./Notifications/Notification"));
const ChooseNotification = React.lazy(() => import("./Notifications/ChooseNotification"));
const AddNotification = React.lazy(() => import("./Notifications/AddNotification"));
const NotificationSetting = React.lazy(() => import("./Notifications/NotificationSetting"));
const ViewNotification = React.lazy(() => import("./Notifications/ViewNotification"));
const NotificationReview = React.lazy(() => import("./Notifications/NotificationReview"));

const Receipts = React.lazy(() => import("./Finance/Receipts"));
const GstInvoiceFromKisan = React.lazy(() => import("./Finance/GstInvoiceFromKisan"));
const GstInvoiceToKisan = React.lazy(() => import("./Finance/GstInvoiceToKisan"));
const Payment = React.lazy(() => import("./Finance/Payment"));
const Finance = React.lazy(() => import("./Finance/Finance"));

const Users = React.lazy(() => import("./Users/Users"));
const AddUser = React.lazy(() => import("./Users/AddUser"));
const EditUser = React.lazy(() => import("./Users/EditUser"));
const UnconfirmUser = React.lazy(() => import("./Users/UnconfirmUser"));
const Position = React.lazy(() => import("./Users/Position"));
const Farmers = React.lazy(() => import("./Users/Farmers"));
const Dealers = React.lazy(() => import("./Users/Dealers"));
const ServiceProvider = React.lazy(() => import("./Users/ServiceProvider"));
const Agents = React.lazy(() => import("./Users/Agents"));
const Others = React.lazy(() => import("./Users/Others"));

const MobileBanner = React.lazy(() => import("./MobileBanner/MobileBanner"));
const WebBanner = React.lazy(() => import("./MobileBanner/WebBanner"));
const BannerApprovals = React.lazy(() => import("./MobileBanner/BannerApprovals"));
const WebBannerApproval = React.lazy(() => import("./MobileBanner/WebBannerApproval"));
const MobileBannerApprovalDetail = React.lazy(() => import("./MobileBanner/MobileBannerApprovalDetail"));
const NewsEvents = React.lazy(() => import("./MobileBanner/NewsEvents"));
const AddBanner = React.lazy(() => import("./MobileBanner/AddBanner"));

const PostApprovalDetails = React.lazy(() => import("./Postings/PostApprovalDetails"));
const DealerPost = React.lazy(() => import("./Postings/Pages/DealerPost"));
const GeneralPost = React.lazy(() => import("./Postings/Pages/GeneralPost"));
const PrPost = React.lazy(() => import("./Postings/Pages/PrPost"));
const ServicePost = React.lazy(() => import("./Postings/Pages/ServicePost"));
const OfferPost = React.lazy(() => import("./Postings/Pages/OfferPost"));

const Languages = React.lazy(() => import("./Languages"));
const Settings = React.lazy(() => import("./Settings"));
const Price = React.lazy(() => import("./Settings/Price"));
const DealerLeads = React.lazy(() => import("./Leads/DealerLeads"));
const MilkCollection = React.lazy(() => import("./Milkmodule/MilkCollection"));
const Agri = React.lazy(() => import("./Users/Agri"));
const AgriApprovals = React.lazy(() => import("./Approvels/AgriApprovals"));
const AgriPost = React.lazy(() => import("./Postings/Pages/AgriPost"));
const UserStoryPost = React.lazy(() => import("./Postings/Pages/UserStoryPost"));
const StoryApprovalDetail = React.lazy(() => import("./Story/StoryApprovalDetail"));
const PriceSettings = React.lazy(() => import("./PurchaseRequestPriceSetting"));
const PurchaseRequestPriceSetting = React.lazy(() => import("./PurchaseRequestPriceSetting"));
const PurchaseRequestDetail = React.lazy(() => import("./Postings/Pr/PurchaseRequestDetail"));

export default function Home() {
  return (
    
      <Layout>
        <React.Suspense fallback={<div className="d-flex justify-content-center p-5">Loading...</div>}>
          <Routes>
          {/* Dashboard */}
          <Route exact path="/DASHBOARD" element={<Dashboard />} />

          {/* Approvals */}
          <Route path="/OBA/DealerApprovals" element={<DealerApprovals />} />
          <Route path="/OBA/SpApprovals" element={<SpApprovals />} />
          <Route path="/OBA/AgentsApprovals" element={<AgentsApprovals />} />
          <Route path="/OBA/AgriApprovals" element={<AgriApprovals />} />
          <Route
            path="/approvel_detail/:id/:status/:accessId"
            element={<ApprovalDetail />}
          />

          {/* Packages */}
          <Route path="/PACKAGES_FREE" element={<FreePackageList />} />
          <Route path="/PACKAGES_DEALER" element={<DealerPlanList />} />
          <Route
            path="/AgentPACKAGES_DEALER"
            element={<AgentDealerPlanList />}
          />
          <Route path="/PACKAGES_GENERAL" element={<General />} />
          <Route path="/Package/AddZone" element={<AddZone />} />
          <Route
            path="/Package/PushNotification"
            element={<PushNotification />}
          /> {/* ✅ Added missing route */}

          {/* Categories */}
          <Route path="/CATEGORIES" element={<CategoryList />} />
          <Route path="/add_category" element={<AddCategory />} />
          <Route path="/edit_category/:id" element={<EditCategory />} />
          <Route path="/addOfferCategory" element={<AddOfferCategory />} />
          <Route
            path="/editOfferCategory/:id"
            element={<EditOfferCategory />}
          />

          {/* Reviews & Reports */}
          <Route path="/REVIEW_APPROVE" element={<ReviewApprove />} />
          <Route path="/MIS_REPORT" element={<MisReport />} />
          <Route path="/ViewInvoice/:id/:date" element={<Invoice />} />

          {/* Notifications */}
          <Route path="/Notification" element={<Notification />} />
          <Route path="/Choose-Notification" element={<ChooseNotification />} />
          <Route
            path="/Notification-Setting"
            element={<NotificationSetting />}
          />
          <Route
            path="/Add-Notification/:type"
            element={<AddNotification />}
          />
          <Route
            path="/Edit-Notification/:type/:id"
            element={<AddNotification />}
          />
          <Route path="/View-Notification/:id" element={<ViewNotification />} />
          <Route
            path="/Notification-Review"
            element={<NotificationReview />}
          />

          {/* Finance */}
          <Route path="/Receipts" element={<Receipts />} />
          <Route path="/All-Finance" element={<Finance />} />
          <Route
            path="/GstInvoiceFromKisan"
            element={<GstInvoiceFromKisan />}
          />
          <Route path="/GstInvoiceToKisan" element={<GstInvoiceToKisan />} />
          <Route path="/Payment" element={<Payment />} />

          {/* Users */}
          <Route path="/Users" element={<Users />} />
          <Route path="/AddUser" element={<AddUser />} />
          <Route path="/EditUser/:id" element={<EditUser />} />
          <Route path="/Unconfirmed-Users" element={<UnconfirmUser />} />
          <Route path="/Position" element={<Position />} />
          <Route path="/User/Farmers" element={<Farmers />} />
          <Route path="/User/Dealers" element={<Dealers />} />
          <Route path="/User/ServiceProvider" element={<ServiceProvider />} />
          <Route path="/User/Agents" element={<Agents />} />
          <Route path="/User/Agri" element={<Agri />} />
          <Route path="/User/Others" element={<Others />} />

          {/* Banners */}
          <Route
            path="/Banner-Approval-Detail-Mobile/:id"
            element={<MobileBannerApprovalDetail />}
          />
          <Route
            path="/Banner-Approval-Detail-Web/:id"
            element={<WebBannerApproval />}
          />
          <Route path="/AddBanner" element={<AddBanner />} />
          <Route path="/NewsEvents" element={<NewsEvents />} />
          <Route path="/WebBanner" element={<WebBanner />} />
          <Route path="/BannerApprovals" element={<BannerApprovals />} />
          <Route path="/MobileBanner" element={<MobileBanner />} />

          {/* Postings */}
          <Route path="/post_detail/:id" element={<PostApprovalDetails />} />
          <Route path="/story_detail/:id" element={<StoryApprovalDetail />} />
          <Route path="/pr_detail/:id" element={<PurchaseRequestDetail />} />
          <Route path="/POSTINGS/GEN/:status" element={<GeneralPost />} />
          <Route path="/POSTINGS/DEALER/:status" element={<DealerPost />} />
          <Route path="/POSTINGS/Sp/:status" element={<ServicePost />} />
          <Route path="/POSTINGS/Offer/:status" element={<OfferPost />} />
          <Route path="/POSTINGS/Agri/:status" element={<AgriPost />} />
          <Route path="/POSTINGS/UserStory/:status" element={<UserStoryPost />} />
          <Route path="/POSTINGS/PR/:status" element={<PrPost />} />

          {/* Leads & Milk */}
          <Route path="/Lead/DealerLeads" element={<DealerLeads />} />
          <Route path="/Milk/Collection" element={<MilkCollection />} />

          {/* Settings */}
          <Route path="/MASTERS" element={<Languages />} />
          <Route path="/AGENT-SETTINGS" element={<Settings />} />
          <Route path="/PRICE-SETTINGS" element={<Price />} />
          <Route path="/Lead-Price-Setting" element={<PurchaseRequestPriceSetting />} />
        </Routes>
        </React.Suspense>
      </Layout>
      
  );
}
